// Nur Bootstrap-Funktionen und -Variablen laden: sie erzeugen keinen CSS-Output.
// Das komplette Bootstrap-Stylesheet kommt bereits global aus assets/scss/main.scss.
@import '../../styles/bootstrap-tokens';

.SurveyGroupLabel {
    color: #212529;
    font: normal normal bold 16px/24px $font-family-sans-serif;
}

.SurveyQuestionCard {
    padding: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.QuestionInputWrapper {
}

.SurveyQuestionGroup {
    padding: 0;
    width: 100%;
    height: 100%;

    & > div:not(:last-child) {
        margin-bottom: 1rem;
    }
}
